var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiciansContractsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    enableBackground: "new 0 0 88 88",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000118363331681578581120000006054299814428426387_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    points: "61,13.5 22.8,13.5 22.8,74.6 72,74.6  72,24.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#E9D95B",
    strokeWidth: 0.47,
    strokeMiterlimit: 10,
    points: "60.2,15.3 24.3,15.3 24.3,72.7  70.5,72.7 70.5,25.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#DCCC58",
    strokeWidth: 0.44,
    strokeMiterlimit: 10,
    points: "59.4,17.2 25.8,17.2 25.8,70.8  69,70.8 69,26.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#CEC054",
    strokeWidth: 0.41,
    strokeMiterlimit: 10,
    points: "58.6,19 27.3,19 27.3,69 67.5,69  67.5,28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#C1B451",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    points: "57.7,20.9 28.8,20.9 28.8,67.1  66,67.1 66,29.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#B3A74D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    points: "56.9,22.7 30.3,22.7 30.3,65.3  64.5,65.3 64.5,30.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#A59B49",
    strokeWidth: 0.32,
    strokeMiterlimit: 10,
    points: "56.1,24.6 31.7,24.6 31.7,63.4  63,63.4 63,31.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#988F46",
    strokeWidth: 0.29,
    strokeMiterlimit: 10,
    points: "55.2,26.4 33.2,26.4 33.2,61.6  61.5,61.6 61.5,32.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#8A8342",
    strokeWidth: 0.26,
    strokeMiterlimit: 10,
    points: "54.4,28.3 34.7,28.3 34.7,59.7  60.1,59.7 60.1,33.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#7C763E",
    strokeWidth: 0.23,
    strokeMiterlimit: 10,
    points: "53.6,30.1 36.2,30.1 36.2,57.9  58.6,57.9 58.6,35.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#6F6A3B",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    points: "52.8,32 37.7,32 37.7,56 57.1,56  57.1,36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#615E37",
    strokeWidth: 0.17,
    strokeMiterlimit: 10,
    points: "51.9,33.8 39.2,33.8 39.2,54.2  55.6,54.2 55.6,37.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#545134",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    points: "51.1,35.7 40.7,35.7 40.7,52.3  54.1,52.3 54.1,38.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#464530",
    strokeWidth: 0.11,
    strokeMiterlimit: 10,
    points: "50.3,37.6 42.2,37.6 42.2,50.4  52.6,50.4 52.6,39.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#38392C",
    strokeWidth: 0.08,
    strokeMiterlimit: 10,
    points: "49.4,39.4 43.7,39.4  43.7,48.6 51.1,48.6 51.1,41.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#2B2C29",
    strokeWidth: 0.04,
    strokeMiterlimit: 10,
    points: "48.6,41.3 45.2,41.3  45.2,46.7 49.6,46.7 49.6,42.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1D2025",
    strokeWidth: 0.01,
    strokeMiterlimit: 10,
    points: "47.8,43.1 46.7,43.1  46.7,44.9 48.1,44.9 48.1,43.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23.1,
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    width: 3.3,
    height: 41.4
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.47,
    strokeMiterlimit: 10,
    points: "17.6,68.2 16.1,64.9 19.1,64.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.47,
    strokeMiterlimit: 10,
    d: "M17.6,19.8L17.6,19.8c0.9,0,1.6,0.7,1.6,1.6 l0,0v1.6l0,0H16l0,0v-1.6C16,20.5,16.7,19.8,17.6,19.8L17.6,19.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 23,
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    width: 0,
    height: 41.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiciansContractsIcon);
export default __webpack_public_path__ + "static/media/physiciansContractsIcon.3a9041f73a037d0f0fa223b92982f03c.svg";
export { ForwardRef as ReactComponent };